import type { AdminActivityEntry } from '@casetrace/shared';
import { formatDateTime } from './admin-format';

interface AdminActivityListProps {
  activities: readonly AdminActivityEntry[];
}

function actorLabel(activity: AdminActivityEntry): string {
  return activity.actorDisplayName || activity.actorEmail || activity.actorUserId;
}

function targetLabel(activity: AdminActivityEntry): string {
  if (activity.caseName) {
    return activity.caseName;
  }
  if (activity.targetType && activity.targetId) {
    return `${activity.targetType}: ${activity.targetId}`;
  }
  return 'Global aktivitet';
}

export function AdminActivityList({ activities }: AdminActivityListProps) {
  return (
    <section className="rounded-lg border border-white/[0.07] bg-surface p-4">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-sm font-semibold text-text-primary">Hendelser</h2>
        <span className="text-xs text-text-tertiary">Viser {activities.length}</span>
      </div>
      <div className="space-y-2">
        {activities.length === 0 ? (
          <p className="text-xs text-text-tertiary">Ingen aktivitet registrert.</p>
        ) : (
          activities.map((activity) => (
            <div key={activity.id} className="rounded-md bg-white/3 px-3 py-2">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <p className="text-xs font-medium text-text-primary">{activity.action}</p>
                <span className="text-[11px] text-text-tertiary">
                  {formatDateTime(activity.timestamp)}
                </span>
              </div>
              <p className="mt-1 text-[11px] text-text-tertiary">
                {actorLabel(activity)} · {targetLabel(activity)}
              </p>
            </div>
          ))
        )}
      </div>
    </section>
  );
}
